import React from 'react';

/** Free-meter chip shown on a story a free member is reading with their
 *  monthly credit. Paid/comp readers and anonymous visitors see nothing. */
const MeterChip = ({ meter }) => {
  if (!meter || meter.unlimited || !meter.limit) return null;
  const left = Math.max(meter.remaining ?? 0, 0);
  return (
    <span
      data-testid="meter-chip"
      className="inline-flex items-center gap-1.5 rounded-full border border-red-700/60 bg-red-950/40 px-3 py-1 text-[10px] font-black uppercase tracking-[0.2em] text-red-300"
    >
      {left > 0
        ? `${left} free ${left === 1 ? 'story' : 'stories'} left this month`
        : 'Last free story this month'}
    </span>
  );
};

export default MeterChip;
